import { render, staticRenderFns } from "./PosOptimizationForm.vue?vue&type=template&id=581440fd&scoped=true&"
import script from "./PosOptimizationForm.vue?vue&type=script&lang=js&"
export * from "./PosOptimizationForm.vue?vue&type=script&lang=js&"
import style0 from "./PosOptimizationForm.vue?vue&type=style&index=0&id=581440fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581440fd",
  null
  
)

export default component.exports